// America/Curacao is fixed UTC-4, no DST.
const CW_OFFSET_MIN = -4 * 60;

export function xcg(amount) {
  const n = Number(amount || 0);
  return `XCG ${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Convert an ISO string (UTC or with tz) to a Curacao Date object (as-of-wall-clock)
function toCwDate(iso) {
  const d = new Date(iso);
  // shift by (local offset - CW offset) to get a Date whose UTC methods reflect CW wall time
  const local = d.getTime() + d.getTimezoneOffset() * 60000;
  return new Date(local + CW_OFFSET_MIN * 60000);
}

export function cwNow() {
  return toCwDate(new Date().toISOString());
}

// Today's date in Curacao, as YYYY-MM-DD
export function cwTodayISO() {
  const d = cwNow();
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// e.g. "Tue 12 Mar"
export function cwPrettyDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dt.getUTCDay()];
  const mo = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][dt.getUTCMonth()];
  return `${wd} ${d} ${mo}`;
}

export function cwTimeHM(iso) {
  if (!iso) return '';
  const d = toCwDate(iso);
  const h = String(d.getUTCHours()).padStart(2, '0');
  const m = String(d.getUTCMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}

// "waiting 6 hours", "waiting 2 days"
export function humanWaiting(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const now = Date.now();
  const mins = Math.max(0, Math.floor((now - then) / 60000));
  if (mins < 60) return `waiting ${mins} min${mins === 1 ? '' : 's'}`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 48) return `waiting ${hrs} hour${hrs === 1 ? '' : 's'}`;
  const days = Math.floor(hrs / 24);
  return `waiting ${days} day${days === 1 ? '' : 's'}`;
}

// "arriving in 2 days", "arriving today", "arriving tomorrow", "arrived 3 days ago"
export function humanArrival(dateStr) {
  const today = cwTodayISO();
  if (dateStr === today) return 'arriving today';
  const [y1, m1, d1] = today.split('-').map(Number);
  const [y2, m2, d2] = dateStr.split('-').map(Number);
  const a = Date.UTC(y1, m1 - 1, d1);
  const b = Date.UTC(y2, m2 - 1, d2);
  const days = Math.round((b - a) / 86400000);
  if (days === 1) return 'arriving tomorrow';
  if (days > 1) return `arriving in ${days} days`;
  if (days === -1) return 'arrived yesterday';
  return `arrived ${-days} days ago`;
}

export function nightsBetween(ci, co) {
  const [y1, m1, d1] = ci.split('-').map(Number);
  const [y2, m2, d2] = co.split('-').map(Number);
  return Math.max(0, Math.round((Date.UTC(y2, m2 - 1, d2) - Date.UTC(y1, m1 - 1, d1)) / 86400000));
}

export function humanCheckedInAt(iso) {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const now = Date.now();
  const mins = Math.max(0, Math.floor((now - then) / 60000));
  if (mins < 60) return `checked in ${mins} min${mins === 1 ? '' : 's'} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `checked in at ${cwTimeHM(iso)}`;
  const days = Math.floor(hrs / 24);
  return `checked in ${days} day${days === 1 ? '' : 's'} ago`;
}

export function hoursSince(iso) {
  const then = new Date(iso).getTime();
  return Math.max(0, (Date.now() - then) / 3600000);
}
